// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "product_lot".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "product_lot" table (1:1 with a DB row, on the wire). */
export const productLotAtomSchema = z.object({
    id: z.string(),
    productId: z.string(),
    locationId: z.string(),
    lot: z.string(),
    expiry: z.string().datetime(),
    quantity: z.number(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=productLot.js.map